/* eslint-disable max-len */
/* eslint-disable camelcase */
import React, { useEffect, useState } from "react";
import get from "lodash/get";
import { connect, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { NavBar } from "./nav-bar";
import {
  fetchSponsorshipsLeft,
  createSponsoredChild,
} from "../pages/AccountDetails/sponsor-api";

import { getIntegrationToken } from "../helper/api";

import useSponsoredSubsStore from "../../context/useFreeSubsInfo";

import ModalDialogInline from "../pages/AccountDetails/Dialog";

import "./header.m.css";
// import { enableLogRocket } from "../helper/logger";
// import { checkLoggedInUser } from "../helper/api";
// import { parseUrl } from "query-string";

// Common wrapper for navigation. We could add OffcanvasMenu, Navbar etc components here.
const HeaderBase = (props) => {
  // const subs = useSelector((state) => {
  //   return state?.fetchSubscription;
  // });
  // const [sponsoredSubsLeft, setsponsoredSubsLeft] = useState(-1);

  const setsponsoredSubsLeft = useSponsoredSubsStore(
    (state) => state.setsponsoredSubsLeft
  );

  const sponsoredSubsLeft = useSponsoredSubsStore(
    (state) => state.sponsoredSubsLeft
  );

  const userSubscriptions = useSelector((state) =>
    get(state, ["fetchSubscription", "items"], [])
  );
  // const activeSub = subs.filter((i) => i?.active === true)[0];

  // const [activeSubs, setActiveSubs] = useState({});
  // // const { isLoading = true } = state.fetchSubscription;

  // let activeSubs;

  // useEffect(() => {
  const activeSubs = userSubscriptions?.filter((i) => i.active === true)[0];

  useEffect(() => {
    if (activeSubs?.id) {
      fetchSponsorshipsLeft(activeSubs?.id, setsponsoredSubsLeft);
      // fetchChildrenForParent(activeSubs.id, setsponsoredChildren);
    }

    return () => {};
  }, [activeSubs]);
  //   return () => {};
  // }, [userSubscriptions]);

  // console.log("active subs", activeSubs?.id, sponsoredSubsLeft);
  // const {
  //   publisher: { auth_host, accessTypeEnvironment },
  //   config: { domainSlug }
  // } = useSelector(({ qt }) => ({
  //   publisher: qt.config.publisher.publisher,
  //   config: qt.config
  // }));

  // const stagingParams = {
  //   callbackUrl: global.location && global.location.href,
  //   clientId: "76",
  //   redirectUrlEnglish:
  //     "https://newslaundry-web.qtstage.io/api/auth/v1/oauth/token",
  //   redirectUrlHindi:
  //     "https://newslaundry-hindi-web.qtstage.io/api/auth/v1/oauth/token"
  // };

  // const productionParams = {
  //   callbackUrl: global.location && global.location.href,
  //   clientId: "560",
  //   redirectUrlEnglish: "https://www.newslaundry.com/api/auth/v1/oauth/token",
  //   redirectUrlHindi: "https://hindi.newslaundry.com/api/auth/v1/oauth/token"
  // };

  // const member = useSelector(state => get(state, ["member"], null));

  const sponsorSubscription = async (email) => {
    // console.log({ activeSubs });

    try {
      const token = await getIntegrationToken();

      await createSponsoredChild(activeSubs.id, email, token);
      setsponsoredSubsLeft(sponsoredSubsLeft - 1);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    // enableLogRocket();
    // const checkSSOAuth = async () => {
    //   const { query } = parseUrl(window.location.href);
    //   if (query && query.logged_in === "false") {
    //     const documentTitle = document.title;
    //     const urlSplit = window.location.href.split("?");
    //     const obj = { Title: documentTitle, Url: `${urlSplit[0]}` };
    //     window.history.pushState(obj, obj.Title, obj.Url);
    //     return;
    //   }
    //   try {
    //     const loggedInResponse = await checkLoggedInUser();
    //     if (loggedInResponse) {
    //       return;
    //     }
    //     window.location.href = `${auth_host}/api/auth/v1/oauth/auto-sso/authorize?client_id=${
    //       accessTypeEnvironment
    //         ? stagingParams.clientId
    //         : productionParams.clientId
    //     }&redirect_uri=${
    //       accessTypeEnvironment
    //         ? domainSlug
    //           ? stagingParams.redirectUrlHindi
    //           : stagingParams.redirectUrlEnglish
    //         : domainSlug
    //         ? productionParams.redirectUrlHindi
    //         : productionParams.redirectUrlEnglish
    //     }&callback_uri=${
    //       accessTypeEnvironment
    //         ? stagingParams.callbackUrl
    //         : productionParams.callbackUrl
    //     }&response_type=code`;
    //     // window.location.href = `${auth_host}/api/auth/v1/oauth/auto-sso/authorize?client_id=76&redirect_uri=https://newslaundry${
    //     //   domainSlug ? "-hindi" : ""
    //     // }-web.qtstage.io/api/auth/v1/oauth/token&callback_uri=https://newslaundry${
    //     //   domainSlug ? "-hindi" : ""
    //     // }-web.qtstage.io&response_type=code`;
    //   } catch (error) {
    //     console.error(error);
    //   }
    // };
    // checkSSOAuth();
  }, []);

  const RenderBanner = () => {
    return (
      <div
        style={{
          backgroundColor: "var(--component-background-accent-solid-default)",
          display: "flex",
          color: "#fff",
          justifyContent: "center",
          padding: "0.30rem 0rem",
          alignItems: "center",
          fontSize: "1.1rem",
          marginBottom: "0.5rem",
        }}
      >
        You have {sponsoredSubsLeft} monthly{" "}
        {sponsoredSubsLeft > 1 ? "subscriptions" : "subscription"} to gift as a
        Gamechanger subscriber benefit. For free!
        {sponsoredSubsLeft > 0 && (
          <ModalDialogInline
            triggerText="Gift free subscription"
            sponsorSubscription={sponsorSubscription}
            sponsoredSubsLeft={sponsoredSubsLeft}
            simpleText
          />
        )}
      </div>
    );
  };

  return (
    <div styleName="container">
      <a href="#container" styleName="skip-link">
        Skip to main content
      </a>
      <NavBar
        {...props}
        RenderBanner={RenderBanner}
        // RenderBanner={<div />}
        sponsoredSubsLeft={sponsoredSubsLeft}
      />
      {sponsoredSubsLeft > 0 && <div style={{ height: "2.2rem" }} />}
    </div>
  );
};

function mapStateToProps(state) {
  return {
    menu: get(state, ["qt", "data", "navigationMenu"], []),
    currentPath: get(state, ["qt", "currentPath"], ""),
  };
}

HeaderBase.propTypes = {
  currentPath: PropTypes.string,
};

export const Header = connect(mapStateToProps, () => ({}))(HeaderBase);
